import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { nbsApiSearchLocation } from '../../../store/actions/searchLocation';
import {
  resetCreateAccountData,
  setUserCreateAccountData,
} from '../../../store/actions/createAccountData';
import { nbsApiEmailRegister } from '../../../store/actions/emailRegister';
import { nbsApiEmailLogin } from '../../../store/actions/emailLogin';
import { nbsApiCheckUsername } from '../../../store/actions/checkUsername';
import { setSessionToken } from '../../../store/actions/session';
import { nbsApiTransCoregLookup } from '../../../store/actions/transCoregLookup';
import EmailRegisterInner from '../../../components/Auth/EmailRegisterInner/EmailRegisterInner';
import { makeDob } from '../../../assets/helpers/dateTimeUtils';
import { gtmTrack } from '../../../assets/helpers/GAHelper';
import {
  getLandingId,
  prepareAffiliateParams,
} from '../../../assets/helpers/affiliateHelper';
import {
  getRomanceGuardParam,
  getNewSeekingValue,
  getGenderSeekingComboByWeight,
  getOldSeekingValue,
  getConfigIndexValueForGenderAndSeekingBasedOnGenders,
  uuid,
} from '../../../assets/helpers/utils';

class EmailRegisterInnerContainer extends Component {
  state = {
    isTransCoregOfferChecked: false,
    transCoregText: '',
    showTransCoregCheckbox: false,
    genderSeekingComboSet: false,
  };

  componentDidMount() {
    // Set Initial TransCoreg Offer State
    this.setState({
      isTransCoregOfferChecked: this.props.createAccountData.bonus,
    });

    // If getConfig is already available, initialize account data
    if (this.props.getConfig.status === 'success') {
      this.initializeGenderSeeking(this.props.getConfig.response);
    }

    // Set Initial Location if Available
    if (this.props.myLocation.status === 'success') {
      this.setUserLocation(this.props.myLocation.response);
    }
  }

  componentDidUpdate(prevProps) {
    // Handle Config Updates
    if (
      this.props.getConfig.status === 'success' &&
      prevProps.getConfig.status !== 'success'
    ) {
      this.initializeGenderSeeking(this.props.getConfig.response);
    }

    // Handle Location Updates
    if (
      this.props.myLocation.status === 'success' &&
      prevProps.myLocation.status !== 'success'
    ) {
      this.setUserLocation(this.props.myLocation.response);
    }

    // Handle Email Registration Success
    if (
      this.props.emailRegister.status === 'success' &&
      prevProps.emailRegister.status !== 'success' &&
      this.props.emailRegister.fromPage === 'StepFive-inner'
    ) {
      this.emailLogin();
      gtmTrack({
        event: 'sign_up',
        signup_type: 'home',
        method: 'email',
        user_id: this.props.emailRegister.response.user_id,
      });
    }

    // Handle Email Registration Failure
    if (
      this.props.emailRegister.status === 'fail' &&
      prevProps.emailRegister.status !== 'fail' &&
      this.props.emailRegister.fromPage === 'StepFive-inner'
    ) {
      gtmTrack({
        event: 'signup_error',
        message: this.props.emailRegister.error.error,
      });
    }

    // Handle Email Login Success
    if (
      this.props.emailLogin.status === 'success' &&
      prevProps.emailLogin.status !== 'success'
    ) {
      this.props.setSessionToken(this.props.emailLogin.response.token);
      this.props.resetCreateAccountData();
    }

    // Handle Email Login Failure
    if (
      this.props.emailLogin.status === 'fail' &&
      prevProps.emailLogin.status !== 'fail'
    ) {
      gtmTrack({
        event: 'signup_error',
        message: this.props.emailLogin.error.error,
      });
    }
  }

  /**
   * Initializes gender and seeking values based on getConfig response.
   */
  initializeGenderSeeking = (configResponse) => {
    if (!this.state.genderSeekingComboSet) {
      const stats = getGenderSeekingComboByWeight(
        configResponse.genders_seeking_stats
      );
      if (stats) {
        const { gender, seeking } = stats;
        const oldSeekingValue = getOldSeekingValue(seeking);
        const genderSelectedIndex =
          getConfigIndexValueForGenderAndSeekingBasedOnGenders(
            gender,
            oldSeekingValue
          );

        this.props.setUserCreateAccountData({
          minAge: configResponse.allowed_ages.min,
          maxAge: configResponse.allowed_ages.max,
          gender,
          seeking: oldSeekingValue,
          genderAndSeekingSelectedValue: genderSelectedIndex,
        });

        this.setState({ genderSeekingComboSet: true });
      } else {
        this.props.setUserCreateAccountData({
          minAge: configResponse.allowed_ages.min,
          maxAge: configResponse.allowed_ages.max,
          gender: 1,
          seeking: 2,
        });
      }
    } else {
      this.props.setUserCreateAccountData({
        minAge: configResponse.allowed_ages.min,
        maxAge: configResponse.allowed_ages.max,
      });
    }
  };

  /**
   * Updates user location data.
   */
  setUserLocation = ({ lat, place, country, lon, lng }) => {
    const location = /undefined/gi.test(place) ? '' : place;
    this.props.setUserCreateAccountData({
      location,
      lon: lon || lng,
      lat,
      country,
    });
  };

  setGenderAndSeeking = (data) => {
    this.props.setUserCreateAccountData(data);
  };

  setUsername = (username) => {
    this.props.setUserCreateAccountData({ username });
  };

  setLocation = (location, lat, lon, country) => {
    this.props.setUserCreateAccountData({ location, lat, lon, country });
  };

  setAge = (age) => {
    this.props.setUserCreateAccountData({ age });
  };

  setEmail = (email) => {
    this.props.setUserCreateAccountData({ email });
  };

  setPassword = (password) => {
    this.props.setUserCreateAccountData({ password });
  };

  getTransCoreg = (email, country) => {
    this.props.nbsApiTransCoregLookup({ email, country });
  };

  toggleTransCoregOffer = () => {
    this.setState({
      isTransCoregOfferChecked: !this.state.isTransCoregOfferChecked,
    });
    this.props.setUserCreateAccountData({
      bonus: !this.state.isTransCoregOfferChecked,
    });
  };

  setTransCoreg = (show, msg) => {
    this.setState({ showTransCoregCheckbox: show, transCoregText: msg });
  };

  createAccount = () => {
    const { gender, seeking, username, email, password, age, lat, lon } =
      this.props.createAccountData;
    const dob = makeDob(age);
    const obj = {
      signup_type: 'regular',
      sex: gender,
      dob,
      age,
      email,
      password,
      lat,
      lon,
      // pref_sex: seeking,
      pref_sex: getNewSeekingValue(seeking),
      coreg: 0,
      username,
      platform: 'web',
      __RG: getRomanceGuardParam(),
    };
    const landingId = getLandingId();
    if (landingId !== '') {
      const affParams = prepareAffiliateParams({}, true);
      for (let key in affParams) {
        obj[key] = affParams[key];
      }
    }

    if (this.state.isTransCoregOfferChecked) {
      obj.trans_coreg_id = this.props.transCoregLookup.response.trans_coreg_id;
    }

    if (this.props.metaPixels.fbc) {
      obj.meta_fbc = this.props.metaPixels.fbc;
    }

    if (this.props.metaPixels.fbp) {
      obj.meta_fbp = this.props.metaPixels.fbp;
    }

    obj.meta_event_id = uuid();

    // console.log('CREATE ACCOUNT Inner!!!!!!', obj);
    this.props.nbsApiEmailRegister(obj, 'StepFive-inner');
  };

  emailLogin = () => {
    const { email, password } = this.props.createAccountData;
    const obj = {
      email,
      password,
      login_type: 'regular',
      device_type: 3,
      __RG: getRomanceGuardParam(),
    };
    this.props.nbsApiEmailLogin(obj);
  };

  render() {
    // console.log('EMAIL REGISTERINNER CONTAINER RENDER:::::', this.props);
    return (
      <EmailRegisterInner
        {...this.state}
        {...this.props.createAccountData}
        isLandscape={this.props.isLandscape}
        step={this.props.step}
        goToStep={this.props.goToStep}
        setGenderAndSeeking={this.setGenderAndSeeking}
        setUsername={this.setUsername}
        setLocation={this.setLocation}
        setAge={this.setAge}
        setEmail={this.setEmail}
        setPassword={this.setPassword}
        createAccount={this.createAccount}
        nbsApiSearchLocation={this.props.nbsApiSearchLocation}
        searchLocation={this.props.searchLocation}
        checkUsername={this.props.checkUsername}
        nbsApiCheckUsername={this.props.nbsApiCheckUsername}
        emailRegister={this.props.emailRegister}
        emailLogin={this.props.emailLogin}
        goBack={this.props.goBack}
        transCoregLookup={this.props.transCoregLookup}
        getTransCoreg={this.getTransCoreg}
        toggleTransCoregOffer={this.toggleTransCoregOffer}
        getConfig={this.props.getConfig}
        setTransCoreg={this.setTransCoreg}
        toggleMinHeight={this.props.toggleMinHeight}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    myLocation: state.myLocation,
    getConfig: state.getConfig,
    searchLocation: state.searchLocation,
    createAccountData: state.createAccountData,
    emailRegister: state.emailRegister,
    checkUsername: state.checkUsername,
    emailLogin: state.emailLogin,
    transCoregLookup: state.transCoregLookup,
    metaPixels: state.metaPixels,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiSearchLocation,
      resetCreateAccountData,
      setUserCreateAccountData,
      nbsApiEmailRegister,
      nbsApiCheckUsername,
      nbsApiEmailLogin,
      setSessionToken,
      nbsApiTransCoregLookup,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailRegisterInnerContainer);
